import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import {
  ICreateRosterParams,
  IGetRostersParams,
  IGetRosterParams,
  IPutRosterParams,
  IRoster,
  IGetRostersInvitesHistoryParams,
  IRosterInviteHistory,
} from 'models/Roster'
import { IPayload } from 'models/Global'

export class BusinessRostersApi {
  constructor(private axios: AxiosService) {}

  getRosters = async (params?: IGetRostersParams) => {
    const response = await this.axios.get<IPayload<IRoster[]>>(Endpoints.getRosters, params)
    return response
  }

  deleteRoster = async (rosterId: number) => {
    const response = await this.axios.delete(Endpoints.deleteRoster(rosterId))
    return response
  }

  getRoster = async (rosterId: number, params?: IGetRosterParams) => {
    const response = await this.axios.get<IPayload<IRoster>>(Endpoints.getRoster(rosterId), params)
    return response
  }

  putRoster = async (rosterId: number, params: IPutRosterParams) => {
    const response = await this.axios.put<IPayload<IRoster>>(Endpoints.putRoster(rosterId), params)
    return response
  }

  deleteRosterMembers = async (rosterId: number, userIds: number[]) => {
    const response = await this.axios.delete(Endpoints.deleteRosterMembers(rosterId), {
      member_ids: userIds,
    })
    return response
  }

  addRosterMembers = async (rosterId: number, userIds: number[]) => {
    const response = await this.axios.post(Endpoints.addRosterMembers(rosterId), {
      member_ids: userIds,
    })
    return response
  }

  postRoster = async (params: ICreateRosterParams) => {
    const response = await this.axios.post<IPayload<IRoster>>(Endpoints.postRoster, params)
    return response
  }

  getRostersInvitesHistory = async (params: IGetRostersInvitesHistoryParams) => {
    const response = await this.axios.get<IPayload<IRosterInviteHistory[]>>(
      Endpoints.getRostersInvitesHistory,
      params
    )
    return response
  }
}
